export default [
  {
    position: "absolute",
    top: 0.6,
    left: 0.4,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 9,
    tooltipText: "homeDashTeamP2.ttTextOne",
    hover: false,
    tooltipClass: "right",
    id: "SP_TeamMember_Navigation_Menu",
    index: 0,
  },
  {
    position: "absolute",
    top: 4.7,
    left: 13.1,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 0,
    tooltipText: "homeDashTeamP2.ttTextSeven",
    hover: false,
    id: "SP_TeamMember_Navigation_Communications",
    index: 1,
  },
  {
    position: "absolute",
    top: 4.7,
    left: 35.5,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 3,
    tooltipText: "homeDashTeamP2.ttTextTwo",
    hover: false,
    id: "SP_TeamMember_Navigation_PayBenefits",
    index: 2,
  },
  {
    position: "absolute",
    top: 4.7,
    left: 43.4,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 6,
    tooltipText: "homeDashTeamP2.ttTextThree",
    hover: false,
    id: "SP_TeamMember_Navigation_Absence",
    index: 3,
  },
  {
    position: "absolute",
    top: 4.7,
    left: 50.4,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 7,
    tooltipText: "homeDashTeamP2.ttTextFour",
    hover: false,
    id: "SP_TeamMember_Navigation_Performance",
    index: 4,
  },
  {
    position: "absolute",
    top: 4.7,
    left: 69.2,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 11,
    tooltipText: "homeDashTeamP2.ttTextFive",
    hover: false,
    id: "SP_TeamMember_Navigation_Hiring",
    index: 5,
  },
  {
    position: "absolute",
    top: 19,
    left: 95.5,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 2,
    tooltipText: "homeDashTeamP2.ttTextSix",
    hover: false,
    tooltipClass: "left",
    id: "SP_TeamMember_Navigation_GeraldHowell",
    index: 6,
  },
];
